import {Block} from '../../models/Block';
import {Expander} from '../expanded_parts/Expander';
import {calculateDurationMs} from './calculateDurationMs';

export class DurationCalculator {
    public static ms(blocks: Block[]): number {
        const expander = new Expander();
        return expander.expand(blocks).reduce((p, c) => {
            return p + calculateDurationMs(c.part);
        }, 0);
    }
}
